export const ANIME_CONFIG = {
  easing: 'easeInOutSine',
  direction: 'alternate',
  loop: true,
  duration: 1000,
  endDelay: 350,
}
